import styled from 'styled-components';

import { FlexDiv } from 'commonStyles';

export const VideoOverlay = styled(FlexDiv)`
	z-index:2;
	left: 20px;
	top: 20px;
`;

export const PlayBtn = styled.button`
  width: 60px;
  height: 60px;
  background: #ffffff;
  margin-bottom: 8px;
  &:focus {
    outline: none;
  }
  border: none;
  border-radius: 100%;
  cursor: pointer;
  &::after {
    content: "";
    display: inline-block;
    position: relative;
    top: 1px;
    left: 3px;
    border-style: solid;
    border-width: 10px 0 10px 16px;
    border-color: transparent transparent transparent #ff664b;
  }
`;
